import { NavLink, Outlet } from 'react-router-dom';
import '../../styles/building-maintenance-mock.css';

const navItems = [
  { to: '.', label: '全体ダッシュボード', testId: 'bm-nav-dashboard', end: true },
  { to: 'areas', label: '階層メニュー', testId: 'bm-nav-areas' },
  { to: 'inspections', label: '法定点検', testId: 'bm-nav-inspections' },
];

export function BuildingMaintenanceMockLayout() {
  return (
    <div className="bm2-page">
      <div className="bm2-shell">
        <aside className="bm2-side">
          <div className="bm2-brand">
            <div className="bm2-brand-mark">一元</div>
            <div>
              <div className="bm2-brand-title">ビルメンテ一元帳</div>
              <div className="bm2-brand-sub">必要機能に絞った提案モック</div>
            </div>
          </div>
          <nav className="bm2-nav">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={item.testId}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="bm2-side-note">
            最低限の基本設定だけで運用開始。
            写真・書類・発注は先に受け取り、後からマップ/ビル/階層/部屋や法定点検に紐付けできます。
          </div>
        </aside>
        <div className="bm2-main">
          <header className="bm2-topbar">
            <div>
              <h1>ビルメンテ運用ダッシュボード</h1>
              <p>複数ビルの進捗・業者・法定点検・発注・書類を一枚で見渡す</p>
            </div>
            <div className="bm2-top-actions">
              <button type="button" className="bm2-button ghost">
                写真を追加
              </button>
              <button type="button" className="bm2-button ghost">
                書類をアップ
              </button>
              <button type="button" className="bm2-button primary">
                発注を作成
              </button>
            </div>
          </header>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
